import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export const useTransfer = (transferId: string) => {
  const { projectId } = useParams();

  return useQuery<TransferDto>({
    queryKey: ['transfer', transferId],
    queryFn: () => apiClient.get(`/v1/projects/${projectId}/transfers/${transferId}`),
  });
};
